// extracted by mini-css-extract-plugin
export var banner = "_gr-0";
export var closeButton = "_gr-2";
export var greenCheckmark = "_gr-3";
export var hereLink = "_gr-4";
export var titleIcon = "_gr-1";